<template>
	<section class="page" @click.self="tapBg">
		<div class="cons">
			<img class="icon" src="./img/icon9.png" />
			<p v-text="phoneNumber" />
			<p v-if="lastName" v-text="lastName" />
			<div class="score" v-text="scoreTotal" />
			<a href="./rewards.html" class="opt opt1">Rewards</a>
			<a href="./aboutUs.html" class="opt opt2">About Funpera</a>
			<a href="./service.html" class="opt opt3">Customer service</a>
			<a href="./suggestion.html" class="opt opt4">Suggestion</a>
			<a class="out" @click="logOut">Log Out</a>
		</div>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				phoneNumber: '',
				lastName: '',
				scoreTotal: ''
			}
		},
		metaInfo: {
			title: 'mine'
		},
		mounted: function() {
			let self = this;
			self.getUserInfo();
		},
		methods: {
			//点击背景
			tapBg(){
				var self = this;
				self.$emit('tapBg')
			},

			//获取用户详情
			getUserInfo(){
				var self = this;
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/getUserInfo', {}, function(res){
					self.UTILS.loadGif.hide();
					if(res.code == '0000'){
						self.scoreTotal = res.data.scoreTotal;
						self.phoneNumber = res.data.phoneNumber;
						self.lastName = res.data.lastName;
					}else{
						self.UTILS.logStr(res.message);
					}
				});
			},

			//退出登录
			logOut(){
				var self = this;
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/signOut', {}, function(res){
					self.UTILS.loadGif.hide();
					if(res.code == '0000'){
						self.UTILS.removeParam('cToken');
						location.href = './login.html';
					}else{
						self.UTILS.logStr(res.message);
					}
				});
			}
		}
	}
</script>

<style scoped>
.page{ width: 7.5rem; height: 100%; background: #D8D8D8; background: rgba(216, 216, 216, 0.5); position: fixed; top: 0; left: 50%; margin-left: -3.75rem; z-index: 2;}
.cons{ width: 4.36rem; height: 100%; padding-right: 0.3rem; background: radial-gradient(305% 100% at 50% 0%, #E04E00 0%, #FD59A5 29%, #F97979 75%, #FF5900 100%); border-top-left-radius: 1.8rem; border-bottom-left-radius: 1.8rem; position: absolute; top: 0; right: 0;}
.icon{ width: 1.3rem; height: 1.3rem; display: block; margin: 0.6rem 0 0.3rem 2.8rem;}
.cons p{ line-height: 0.58rem; font-size: 0.32rem; color: #FFFCFC; text-align: right;}
.cons a{ color: #FFFCFC;}
.score{ height: 1.27rem; padding-right: 1.3rem; line-height: 1.27rem; text-align: right; font-size: 0.56rem; color: #FCFCF9; background: url('./img/icon10.png') no-repeat right; background-size: 1.2rem auto;}
.opt{ height: 0.52rem; padding-right: 0.78rem; line-height: 0.52rem; text-align: right; font-size: 0.36rem; display: block; margin-top: 0.4rem;}
.opt1{ background: url('./img/icon11.png') no-repeat right center; background-size: 0.52rem 0.52rem;}
.opt2{ background: url('./img/icon12.png') no-repeat right center; background-size: 0.52rem 0.52rem;}
.opt3{ background: url('./img/icon13.png') no-repeat right center; background-size: 0.52rem 0.52rem;}
.opt4{ background: url('./img/icon14.png') no-repeat right center; background-size: 0.52rem 0.52rem;}
.out{ text-decoration: underline; font-size: 0.36rem; color: #FFF; position: absolute; bottom: 0.9rem; right: 0.3rem;}
</style>
